import React from 'react';
import { cn } from '../../../utils/cn';

export interface SegmentedOption<T extends string = string> {
  value: T;
  label: React.ReactNode;
  icon?: React.ReactNode;
}

export interface SegmentedProps<T extends string = string> {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedOption<T>[];
  className?: string;
  size?: 'sm' | 'md';
  ariaLabel?: string;
}

export function Segmented<T extends string = string>({
  value,
  onChange,
  options,
  className,
  size = 'sm',
  ariaLabel,
}: SegmentedProps<T>) {
  return (
    <div
      className={cn('rt-seg', className)}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          data-on={value === o.value}
          onClick={() => onChange(o.value)}
          className={cn(
            'inline-flex items-center gap-1.5',
            size === 'md' && '!px-3 !py-1.5 !text-[12px]',
          )}
        >
          {o.icon}
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default Segmented;
